import { EnhancedSider } from 'components/page/index';
import { FloatingLabelInput } from 'components/ui/index';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { emptyFn } from 'utils/common';
import { connect } from 'react-redux';
import SiderTabs from '../components/Tabs';

class ReportListSider extends PureComponent {
  constructor() {
    super();
    this.state = {
      searchText: '',
    };
  }
  handleFilterChange = newVal => this.setState({ searchText: newVal })

  render() {
    return (
      <EnhancedSider style={{ padding: '20px 10px' }}>
        <FloatingLabelInput
          handleChange={this.handleFilterChange}
          labelText={<FormattedMessage id="page.ReportListSider.search" />}
          handleSearch={emptyFn}
          withSearch
        />
        <SiderTabs searchText={this.state.searchText} />
      </EnhancedSider >
    );
  }
}

const mapStateToProps = ({ global }) => ({
  lang: global.language,
});
export default connect(mapStateToProps)(ReportListSider);



// WEBPACK FOOTER //
// ./src/views/ReportListSider/container/index.jsx